import React from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

export const SEARCH_FIELD_STYLES = {
  input: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 1,
      bgcolor: 'background.paper',
      color: 'text.primary',
      fontSize: 15,
      '& .MuiInputBase-input': {
        py: '6px',
        color: 'text.primary',
        '&::placeholder': {
          color: 'text.secondary',
          opacity: 1,
        },
      },
      '& fieldset': { borderColor: 'divider' },
      '&:hover fieldset': { borderColor: 'text.disabled' },
      '&.Mui-focused fieldset': { borderColor: 'primary.main', borderWidth: 1 },
    },
  },
  searchIcon: {
    color: 'text.secondary',
    fontSize: 22,
  },
  clearIcon: {
    fontSize: 18,
    color: 'text.secondary',
  },
};

export const searchStartAdornment = (
  <InputAdornment position="start">
    <SearchIcon sx={SEARCH_FIELD_STYLES.searchIcon} />
  </InputAdornment>
);

export const searchClearAdornment = (onClick) => (
  <InputAdornment position="end">
    <IconButton size="small" onClick={onClick} edge="end" sx={{ color: 'text.secondary' }}>
      <ClearIcon sx={SEARCH_FIELD_STYLES.clearIcon} />
    </IconButton>
  </InputAdornment>
);

export default function SearchField({
  value,
  onChange,
  onClear,
  placeholder,
  fullWidth = true,
  size = 'small',
  sx,
  inputProps,
  ...rest
}) {
  const handleClear = () => {
    if (onClear) onClear();
    else if (onChange) onChange('');
  };

  return (
    <TextField
      fullWidth={fullWidth}
      size={size}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange && onChange(e.target.value)}
      sx={{ ...SEARCH_FIELD_STYLES.input, ...sx }}
      InputProps={{
        startAdornment: searchStartAdornment,
        endAdornment: value ? searchClearAdornment(handleClear) : null,
        ...inputProps,
      }}
      {...rest}
    />
  );
}
